module.exports = "/images/vendor/flag-icon-css/flags/4x3/sr.svg?788f3e2af54fdedc56e32d20777fcf5b";